import React, { useState, useEffect } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, TextField, FormControlLabel, Checkbox } from '@mui/material';

const EditDesignModal = ({ handleEditClose, showEditModal, selectedRowData, editRows, onRowsUpdate }) => {
    const [rows, setRows] = useState(editRows);
    const [valueName, setValueName] = useState('');
    const [allowNoteForLot, setAllowNoteForLot] = useState(false);
    const [allowNoteForSerial, setAllowNoteForSerial] = useState(false);
    const [isLotRequired, setIsLotRequired] = useState(false);
    const [isSerialRequired, setIsSerialRequired] = useState(false);
    const [pricing, setPricing] = useState([]);
     const [specialPricings, setSpecialPricings] = useState([]);
    // const [rows, setRows] = useState([]);

    useEffect(() => {
        if (selectedRowData) {
        
          const rowData = selectedRowData[0];
          setValueName(rowData?.valueName || '');
          setAllowNoteForLot(rowData?.allowNoteForLot || false);
          setIsLotRequired(rowData?.isLotRequired || false);
          setAllowNoteForSerial(rowData?.allowNoteForSerial || false);
          setIsSerialRequired(rowData?.isSerialRequired || false);
          
            //   setPricing({
            //     _id: rowData?.pricing[0]?._id,
            //     defaultPrice: rowData?.pricing[0]?.amount || 0,
            //     taxable: rowData?.pricing[0]?.taxable,
            //     rollUpPrice: rowData?.pricing[0]?.rollUpPrice || false,
            //     suppressOnReports: rowData?.pricing[0]?.suppressOnReports || false,
            //     suppressWhenZero: rowData?.pricing[0]?.suppressWhenZero || false,
            //   });
          setPricing(rowData?.pricing)
           setSpecialPricings(rowData?.specialPricing)
        }
      }, [selectedRowData]);
    
      //main checkboxes
      const handleAllowNoteForLot = () => {
        setAllowNoteForLot(!allowNoteForLot);
      };

      const handleAllowNoteForSerial = () => {
        setAllowNoteForSerial(!allowNoteForSerial); // Set the new state
      };

      const handleIsLotRequired = () => {
        setIsLotRequired(!isLotRequired); // Set the new state
      };

      const handleIsSerialRequired = () => {
        setIsSerialRequired(!isSerialRequired); // Set the new state
      };

      
    //   pricing checkboxes

      const handleRollUpPriceChange = (index, e) => {
        const newPricing = [...pricing]; // Create a shallow copy of the current state
        newPricing[index].rollUpPrice = !newPricing[index].rollUpPrice; // Toggle the rollUpPrice
        setPricing(newPricing); // Set the new state
      };

      const handleSuppressWhenZero = (index, e) => {
        const newPricing = [...pricing]; // Create a shallow copy of the current state
        newPricing[index].suppressWhenZero = !newPricing[index].suppressWhenZero; // Toggle the rollUpPrice
        setPricing(newPricing); // Set the new state
      };

      const handleSuppressOnReports = (index, e) => {
        const newPricing = [...pricing]; // Create a shallow copy of the current state
        newPricing[index].suppressOnReports = !newPricing[index].suppressOnReports; // Toggle the rollUpPrice
        setPricing(newPricing); // Set the new state
      };
    
      

      const handleSave = async () => {
        try {
            const putData = {
                valueName,
                allowNoteForLot,
                allowNoteForSerial,
                isLotRequired,
                isSerialRequired,
                pricing,
                specialPricings,
            };


    
            const response = await fetch(`https://hms.backend.hiragroupcloud.com/api/orthodontic-design/${selectedRowData[0]._id}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(putData),
            });
    
            if (!response.ok) {
                throw new Error('Failed to update data');
            }
    
            const updatedRow = await response.json();
            setRows(prevRows =>
                prevRows.map(row => (row._id === updatedRow.data._id ? updatedRow.data : row))
            );
    
            handleEditClose();
        } catch (error) {
            console.error('Error updating data:', error);
            // Optionally show an error message to the user
        }
    };
    


      
        useEffect(() => {
            
        }, [rows]); // Runs whenever 'rows' changes

      const handleValueNameChange = (e) => {
        setValueName(e.target.value)
      }

      

    //   const handleTaxable = (event) => {
    //     setTaxable(event.target.value);
    //   }

    //   pricing
    //   const handleDefaultPrice = () => {

    //   }

      const handleTaxable = (index, e) => {
        const newPricing = [...pricing]; // Create a shallow copy of the current state
        newPricing[index].taxable = e.target.value; // Update the inputValue
        setPricing(newPricing); // Set the new state
      };
        
      const handleDefaultPrice = (index, e) => {
          const newPricing = [...pricing]; // Create a shallow copy of the current state
          newPricing[index].amount = e.target.value; // Update the selectedElement
          setPricing(newPricing); // Set the new state
      };


      //handle special pricings
      
      const handlePrice = (index, e) => {
        const newSpecialPricings = [...specialPricings]; // Create a shallow copy of the current state
        newSpecialPricings[index].price = e.target.value; // Update the selectedElement
        setSpecialPricings(newSpecialPricings); // Set the new state
      };
      const handlePricingFor = (index, e) => {
        const newSpecialPricings = [...specialPricings]; // Create a shallow copy of the current state
        newSpecialPricings[index].pricingFor = e.target.value; // Update the selectedElement
        setSpecialPricings(newSpecialPricings); // Set the new state
      };
      const handleGroup = (index, e) => {
        const newSpecialPricings = [...specialPricings]; // Create a shallow copy of the current state
        newSpecialPricings[index].group = e.target.value; // Update the selectedElement
        setSpecialPricings(newSpecialPricings); // Set the new state
      };
      const handleAccount = (index, e) => {
        const newSpecialPricings = [...specialPricings]; // Create a shallow copy of the current state
        newSpecialPricings[index].account = e.target.value; // Update the selectedElement
        setSpecialPricings(newSpecialPricings); // Set the new state
      };
      const handleProcedure = (index, e) => {
        const newSpecialPricings = [...specialPricings]; // Create a shallow copy of the current state
        newSpecialPricings[index].procedure = e.target.value; // Update the selectedElement
        setSpecialPricings(newSpecialPricings); // Set the new state
      };



  return (
    <>
    <div>{/* Modal for Editing */}
    <Dialog open={showEditModal} onClose={handleEditClose}>
      <DialogTitle>Edit Design Modal</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Value Name"
          type="text"
          fullWidth
          variant="outlined"
          value={valueName}
          onChange={handleValueNameChange}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={isLotRequired === true}
              onChange={handleIsLotRequired}
              color="primary"
            />
          }
          label="Lot Required"
        />
        
        <FormControlLabel
          control={
            <Checkbox
              checked={allowNoteForLot === true}
              onChange={handleAllowNoteForLot}
              color="primary"
            />
          }
          label="Allow Note for Lot"
        />
        
        <FormControlLabel
          control={
            <Checkbox
              checked={isSerialRequired === true}
              onChange={handleIsSerialRequired}
              color="primary"
            />
          }
          label="Serial Required"
        />
        
        <FormControlLabel
          control={
            <Checkbox
              checked={allowNoteForSerial === true}
              onChange={handleAllowNoteForSerial}
              color="primary"
            />
          }
          label="Allow Note for Serial"
        />
        
        {/* Add more fields for pricing, etc. as needed */}
        {/* Pricing */}

        {pricing?.map((column, index) => ( 
            <>
                <div key={column._id} className='row'>
                    <h3>Pricing</h3>
                    <div className='col-md-6'>
                        <TextField
                            // key={column.field}
                            margin="dense"
                            // label={column.headerName}
                            label="Taxable"
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={column.taxable || ''}
                            // value={editData[column.field] || ''}
                            // onChange={(e) => setEditData({ ...editData, [column.field]: e.target.value })}
                            onChange={(e) => handleTaxable(index, e)}
                        />
                    </div>
                    <div className='col-md-6'>
                        <TextField
                            // key={column.field}
                            margin="dense"
                            // label={column.headerName}
                            label="Default Price"
                            type="number"
                            fullWidth
                            variant="outlined"
                            value={column.amount || ''}
                            // value={editData[column.field] || ''}
                            // onChange={(e) => setEditData({ ...editData, [column.field]: e.target.value })}
                            onChange={(e) => handleDefaultPrice(index, e)}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <FormControlLabel
                            control={
                                <Checkbox
                                checked={column.options.rollUpPrice === true}
                                onChange={(e) => handleRollUpPriceChange(index, e)}
                                color="primary"
                                />
                            }
                            label="Never roll-up price into procedure"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                checked={column.options.suppressWhenZero === true}
                                onChange={(e) => handleSuppressWhenZero(index, e)}
                                color="primary"
                                />
                            }
                            label="Suppress this attribute value when price is zero"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                checked={column.options.suppressOnReports === true}
                                onChange={(e) => handleSuppressOnReports(index, e)}
                                color="primary"
                                />
                            }
                            label="Suppress this attribute on reports"
                        />
                    </div>
                </div>
            </>
        ))}


        {specialPricings?.map((column, index) => (
            <div key={column._id} >
                <h3>Special Pricing {index+1}</h3>
                <div className='row'>
                    <div className='col-md-6'>
                        <TextField
                            // key={column.field}
                            margin="dense"
                            label={column.price}
                            // label={column.headerName}
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={column.price}
                            // value={editData[column.field] || ''}
                            // onChange={(e) => setEditData({ ...editData, [column.field]: e.target.value })}
                            onChange={(e) => handlePrice(index, e)}
                        />
                    </div>
                    <div className='col-md-6'>
                        <TextField
                            // key={column.field}
                            margin="dense"
                            label={column.pricingFor}
                            // label={column.headerName}
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={column.pricingFor}
                            // value={editData[column.field] || ''}
                            // onChange={(e) => setEditData({ ...editData, [column.field]: e.target.value })}
                            onChange={(e) => handlePricingFor(index, e)}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <TextField
                            // key={column.field}
                            margin="dense"
                            label={column.group}
                            // label={column.headerName}
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={column.group}
                            // value={editData[column.field] || ''}
                            // onChange={(e) => setEditData({ ...editData, [column.field]: e.target.value })}
                            onChange={(e) => handleGroup(index, e)}
                        />
                    </div>
                    <div className="col-md-6">
                        <TextField
                            // key={column.field}
                            margin="dense"
                            label={column.account}
                            // label={column.headerName}
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={column.account}
                            // value={editData[column.field] || ''}
                            // onChange={(e) => setEditData({ ...editData, [column.field]: e.target.value })}
                            onChange={(e) => handleAccount(index, e)}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <TextField
                            // key={column.field}
                            margin="dense"
                            label={column.procedure}
                            // label={column.headerName}
                            type="text"
                            fullWidth
                            variant="outlined"
                            value={column.procedure}
                            // value={editData[column.field] || ''}
                            // onChange={(e) => setEditData({ ...editData, [column.field]: e.target.value })}
                            onChange={(e) => handleProcedure(index, e)}
                        />
                    </div>
                </div>


            </div>  
        ))} 
      </DialogContent>
      <DialogActions>
        <Button onClick={handleEditClose}>Cancel</Button>
        <Button onClick={handleSave}>Save Change</Button>
      </DialogActions>
    </Dialog>
    </div>
    </>
  )
}

export default EditDesignModal;